import JSZip from "jszip";
import request from "@/utils/request";
import FileSaver from "file-saver";
import axios from "axios";
import store from "../store/index";
import dayjs from "dayjs";
export default {
  //通过url 转为blob格式的数据
  // getImgArrayBuffer(url) {
  //   let _this = this;
  //   return new Promise((resolve, reject) => {
  //     //通过请求获取文件blob格式
  //     let xmlhttp = new XMLHttpRequest();
  //     xmlhttp.open("GET", url, true);
  //     xmlhttp.responseType = "blob";
  //     xmlhttp.onload = function () {
  //       if (this.status == 200) {
  //         resolve(this.response);
  //       } else {
  //         reject(this.status);
  //       }
  //     };
  //     xmlhttp.send();
  //   });
  // },
  // 节流函数
  throttle(func, delay) {
    let timer = null;
    return function (...args) {
      const context = this;
      if (!timer) {
        func.apply(context, args);
        timer = setTimeout(() => {
          timer = null;
        }, delay);
      }
    };
  },
  // 防抖
  debounce(func, delay) {
    let timer = null;
    return function (...args) {
      const context = this;
      if (timer) {
        clearTimeout(timer);
      }
      timer = setTimeout(() => {
        func.apply(context, args);
      }, delay);
    };
  },
  // 批量下载图片
  handleDownloadIMg(imagesParams, name = "活动照片", singleName = '图片-') {
    let count = 0;
    // console.log(row);
    //每次进来清空数组  否则会出现上一次图片不清空的问题
    if (imagesParams.length > 1) {
      // this.imgList = []
      // //把5张图片传进来
      // let imageList = [row.img1, row.img2, row.img3, row.img4, row.img5];
      // imageList.forEach((item) => {
      //   if (item != "") {
      //     this.imgList.push(item);
      //   }
      // });
      //压缩包名
      var blogTitle = name;
      var zip = new JSZip();
      var imgs = zip.folder(blogTitle);
      var baseList = [];
      // 要下载图片的url
      // var arr = this.imgList;
      // 下载后图片的文件名，个数应与arr对应
      var imgNameList = [];
      imagesParams.forEach((item, index) => {
        imgNameList.push(singleName + (index + 1));
      });

      for (var i = 0; i < imagesParams.length; i++) {
        let image = new Image();
        // 解决跨域 Canvas 污染问题
        image.setAttribute("crossOrigin", "anonymous");
        image.onload = function () {
          let canvas = document.createElement("canvas");
          canvas.width = image.width;
          canvas.height = image.height;
          let context = canvas.getContext("2d");
          context.drawImage(image, 0, 0, image.width, image.height);
          let url = canvas.toDataURL(); // 得到图片的base64编码数据
          canvas.toDataURL("image/png");
          baseList.push(url.substring(22)); // 去掉base64编码前的 	data:image/png;base64,
          if (baseList.length === imagesParams.length && baseList.length > 0) {
            for (let k = 0; k < baseList.length; k++) {
              imgs.file(imgNameList[k] + ".png", baseList[k], { base64: true });
            }
            zip.generateAsync({ type: "blob" }).then(function (content) {
              // see FileSaver.js
              FileSaver.saveAs(content, blogTitle + ".zip");
            });
          }
        };
        image.src = imagesParams[i];
      }
    } else {
      // 下载单张图片;
      imagesParams.forEach((item, index) => {
        setTimeout(() => {
          count++;
          var link = document.createElement("a");
          link.id = index;
          link.download = item; //图片文件名
          link.href = item; //文件地址
          link.click();
          link.remove();
          // console.log(count,row.length);
        }, index * 100);
      });
    }
  },
};
